import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const HERO_IMAGE = process.env.REACT_APP_HERO_IMAGE;

export default function HeroSection() {
  return (
    <section data-testid="hero-section" className="relative w-full min-h-[90vh] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="Industrial port at night"
          className="w-full h-full object-cover"
        />
        <div className="hero-overlay absolute inset-0" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 md:py-40">
        <div className="max-w-2xl">
          <p
            className="text-[#DC143C] text-base sm:text-lg uppercase tracking-[0.3em] font-semibold mb-6 opacity-0 animate-fade-in-up whitespace-nowrap"
            style={{ animationDelay: '0.1s', animationFillMode: 'forwards' }}
          >
            Imperial Exim Trading LLC
          </p>
          <h1
            className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-white leading-[1.05] mb-6 opacity-0 animate-fade-in-up"
            style={{ animationDelay: '0.25s', animationFillMode: 'forwards' }}
          >
            Global Trading<br />
            <span className="text-[#DC143C]">Solutions</span> for<br />
            Your Business
          </h1>
          <p
            className="text-[#9CA3AF] text-base md:text-lg leading-relaxed mb-10 max-w-lg opacity-0 animate-fade-in-up"
            style={{ animationDelay: '0.4s', animationFillMode: 'forwards' }}
          >
            Specializing in trailer trading, ferrous &amp; non-ferrous metals,
            and general cargo — connecting businesses across the globe.
          </p>
          <div
            className="flex flex-col sm:flex-row gap-4 opacity-0 animate-fade-in-up"
            style={{ animationDelay: '0.55s', animationFillMode: 'forwards' }}
          >
            <Link
              to="/catalog"
              data-testid="hero-cta-explore"
              className="inline-flex items-center justify-center gap-2 bg-[#DC143C] text-white font-semibold tracking-wide px-7 py-3.5 rounded-md hover:bg-[#B01030] transition-colors"
            >
              Explore Products
              <ArrowRight size={18} />
            </Link>
            <Link
              to="/contact"
              data-testid="hero-cta-contact"
              className="inline-flex items-center justify-center gap-2 border border-white/20 text-white font-semibold tracking-wide px-7 py-3.5 rounded-md hover:bg-white/5 transition-colors"
            >
              Get In Touch
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#05050A] to-transparent" />
    </section>
  );
}
